import Raven from 'raven-js'
import {showErrorToast} from 'redux/modules/ui/toaster/actions'
import {ERROR_GLOBAL, ERROR_GLOBAL_RESET} from './'

export function reportError(text) {
  return dispatch => err => {
    if (typeof text === 'function') {
      text = text(err)
    }
    dispatch(showErrorToast(text || err.message || err))
  }
}

export function handleError(error) {
  Raven.captureException(new Error(error.message), {
    extra: {error}
  })

  return {
    type: ERROR_GLOBAL,
    error
  }
}

export function resetGlobalError(action) {
  return {
    type: ERROR_GLOBAL_RESET
  }
}



// WEBPACK FOOTER //
// ./client/redux/modules/error/actions.js